export const baseIngoingMiddleware = (response) => {
    return response.data
}

export const baseOutgoingMiddleware = (request) => {
    return request
}
